{
  "default": "SparkLayer Dashboard",
  "page": "{title} - SparkLayer Dashboard",
  "pages": {
    "analytics": {
      "analytics": "Analytics",
      "chat": "Analytics Chat",
      "report": "Analytics Report",
      "custom_report": "Analytics Custom Report"
    },
    "auth": {
      "login": "Sign In",
      "register": "Register",
      "partner_register": "Partner Register",
      "enterprise_register": "Register - Enterprise",
      "sales_register": "Register - Sales Pipeline Redirect",
      "two_factor_challenge": "Two-Factor Authentication",
      "register_team_member": "Register Team Member",
      "register_invite": "Invite to Register",
      "forgotten_password": "Forgotten Password",
      "reset_password": "Reset Password",
      "logout": "Sign Out",
      "no_team": "No Team",
      "switch_account": "Switch Account",
      "partners": "Partner Dashboard",
      "settings_password": "Password - Settings"
    },
    "configuration": {
      "onboarding": "Setup - Settings",
      "general": "Configurations - Settings",
      "quote_statuses": "Quote Statuses - Settings",
      "notifications": "Notifications - Settings",
      "invoices": "Invoice Settings - Settings",
      "store_details": "Store Details - Settings",
      "api": "API - Settings",
      "shipping": "Shipping - Settings",
      "shipping_create": "Create Shipping Method - Settings",
      "shipping_edit": "Edit Shipping Method - Settings",
      "theme": "Templates - Settings",
      "theme_editor": "Template Editor"
    },
    "customers": {
      "groups": "Customer Groups",
      "group_create": "Create Customer Group",
      "group_edit": "Edit Customer Group",
      "customers": "Customers",
      "customer_details": "Customer Details",
      "companies": "Companies",
      "company_create": "Create Company",
      "company_edit": "Edit Company",
      "company_sections": "Company Locations",
      "section_create": "Create Location",
      "section_edit": "Edit Location",
      "agents": "Sales Agents",
      "agent_details": "Sales Agent Details",
      "roles": "Roles",
      "role_create": "Create Role",
      "role_edit": "Edit Role"
    },
    "forms": {
      "forms": "Forms"
    },
    "help": {
      "help": "Help"
    },
    "integrations": {
      "platform": "Integrations - Platform",
      "metafields": "Integrations - Platform - Metafields",
      "partners": "Integrations - Partners",
      "products_sync": "Integrations - Product Sync",
      "product_data": "Integrations - Product Data",
      "oauth_brightpearl": "Brightpearl - Integrations (Partner Integrations) - Settings",
      "oauth_katana": "Katana - Integrations (Partner Integrations) - Settings",
      "oauth_quickbooks": "QuickBooks - Integrations (Partner Integrations) - Settings",
      "oauth_xero": "Xero - Integrations (Partner Integrations) - Settings"
    },
    "pricing": {
      "price_lists": "Price Lists",
      "price_list_create": "Create Price List",
      "price_list_edit": "Edit Price List",
      "price_editor": "Price Editor",
      "discounts": "Discounts",
      "discount_create": "Create Discount",
      "discount_edit": "Edit Discount"
    },
    "settings": {
      "account": "Account - Settings",
      "plan": "Plan - Settings",
      "team": "Team - Settings",
      "team_invite": "Invite Team Member - Settings"
    },
    "site": {
      "activity": "Activity",
      "features": "Explore Features"
    },
    "staff": {
      "customer_sync": "Staff - Customer Sync",
      "manage_team": "Staff - Manage Team",
      "manage_billing": "Staff - Manage Billing"
    },
    "storefront": {
      "options": "Storefront - Options",
      "widgets_core": "Widgets (Core Script) - Storefront",
      "widgets_pdp": "Widgets (Product page script) - Storefront",
      "widgets_css": "Widgets (Custom design) - Storefront",
      "widgets_tips": "Widgets (Best-practice tips) - Storefront"
    }
  }
}
